import React from 'react'
import { useTranslation } from '@app/lib/hooks/useTranslation'
import { useRouter } from 'next/router'
import { Translate } from 'next-translate'
import type { InnerApp } from '@app/types/page'
import { strings } from '@app/content/strings/a11y'
import { Footer } from './general'
import { ThemeProvider } from './themes/theme'
import { NavBar } from './blog/navbar'
import { LayoutHead } from './meta/layout-head'
import { Analytics } from '@vercel/analytics/react'
import { isBefore } from 'date-fns'
// import { Provider } from 'react-wrap-balancer'

// show the podcast for 6 months
const cu = new Date()
cu.setMonth(cu.getMonth() + 6)

// load the application with providers depending on component
// TODO: Bring in the header and footer to prevent reloading
const LayoutWrapper = ({
  Component,
  pageProps,
  t,
}: InnerApp & { t: Translate }) => {
  return (
    <ThemeProvider attribute='class' enableSystem>
      <NavBar title={t('common:blog')} podcast={isBefore(new Date(), cu)} />
      <Component {...pageProps} translation={Component?.meta?.translation} />
      <Footer blog />
    </ThemeProvider>
  )
}

export function BlogLayout({ Component, pageProps }: InnerApp) {
  const { description, title, translation } = Component?.meta ?? strings?.meta

  const { t, lang } = useTranslation('common')

  const router = useRouter()
  const pathName = router.pathname

  const metaTitle = translation
    ? t(`${translation}:title`)
    : title || `A11yWatch: ${t('common:web-accessibility')}`
  const metaDescription = translation
    ? t(`${translation}:description`)
    : description

  return (
    <>
      <LayoutHead
        metaTitle={metaTitle}
        metaDescription={metaDescription}
        pathName={pathName}
        lang={lang}
        pageFind
      />
      <LayoutWrapper
        Component={Component}
        pageProps={pageProps}
        pathName={pathName}
        t={t}
      />
      {process.env.NEXT_PUBLIC_ANALYTICS ? <Analytics /> : null}
    </>
  )
}
